import React, { ReactNode } from 'react';

function RoundedStatusTag(props: {
    fill?: 'light-grey' | 'light-green' | 'green' | 'white' | 'caution';
    children?: ReactNode | ReactNode[];
    icon?: string;
    iconLeft?: boolean;
}) {
    let fillClasses = 'bg-light-grey';

    switch(props.fill) {
        case 'light-grey':
            fillClasses = 'bg-light-grey';
            break;
        case 'green':
            fillClasses = 'bg-logo-green text-white';
            break;
        case 'light-green':
            fillClasses = 'bg-teal-200';
            break;
        case 'white':
            fillClasses = 'bg-white';
            break;
        case 'caution':
            fillClasses = 'bg-yellow-200';
            break;
        default:
            fillClasses = 'bg-light-grey';
            break;
    }

    return (
      <button
        type="button"
        className={`inline-flex items-center px-6 py-3 font-bold rounded-xl shadow-sm ${fillClasses}`}
      >
        {props.children}
        { (!props.icon) ? <></> : (
            <img className={`${props.iconLeft ? 'order-first mr-2' : 'ml-2'}`} src={props.icon} alt="" />
        )}
      </button>
    );
}

export default RoundedStatusTag;